import { Link } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const DrilldownLink = ({
  to,
  aggregationTotal
}) => {
  if (aggregationTotal > 0) {
    return /*#__PURE__*/_jsx(Link, {
      to: to,
      children: aggregationTotal
    });
  }
  return aggregationTotal;
};
export default DrilldownLink;